var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wf-search-results-page" },
    [
      [
        _c("div", { staticClass: "wf-search-results-page-header" }, [
          _c("div", { staticClass: "wf-search-results-page-title" }, [
            _vm._v(
              '\n        search results for "' +
                _vm._s(_vm.searchTerm) +
                '":\n      '
            )
          ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wf-anchor-bar" },
          _vm._l(_vm.scopeOptions, function(scopeOption) {
            return _c("anchor-bar-item", {
              key: scopeOption.id,
              attrs: {
                anchor: "#" + scopeOption.id,
                title: scopeOption.title,
                id: scopeOption.id
              }
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("results-collections", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isCollectionsTab,
              expression: "isCollectionsTab"
            }
          ]
        }),
        _vm._v(" "),
        _c(
          "keep-alive",
          [_vm.isStylesTab ? _c("product-search-page") : _vm._e()],
          1
        ),
        _vm._v(" "),
        _c("results-pages", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isPagesTab,
              expression: "isPagesTab"
            }
          ]
        })
      ],
      _vm._v(" "),
      _c("product-compare-container"),
      _vm._v(" "),
      _c("product-compare-modal"),
      _vm._v(" "),
      _c("product-compare-download")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }